import { render } from "./IntellectualPropertyQuery.vue?vue&type=template&id=3ae9cf87&scoped=true"
import script from "./IntellectualPropertyQuery.vue?vue&type=script&lang=js"
export * from "./IntellectualPropertyQuery.vue?vue&type=script&lang=js"

import "./IntellectualPropertyQuery.vue?vue&type=style&index=0&id=3ae9cf87&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ae9cf87"]])

export default __exports__